<template>
    <article class="c-partners">
        <h3 class="t-s-grey">{{ title }}</h3>
        <ul class="c-partners__list">
            <li
                v-for="partner in partners"
                class="c-partners__item">
                <a
                    :href="partner.website"
                    target="_blank"
                    rel="noopener"
                    class="c-partners__link | o-hover-img"
                >
                    <Img
                        v-if="partner.logo"
                        :data-src="partner.logo.url"
                        :alt="partner.logo.title"
                        :width="partner.logo.width"
                        :height="partner.logo.height"
                    ></Img>
                </a>
            </li>
        </ul>
    </article>
</template>

<script>
import Img from 'templates/objects/Img';

export default {
    name: 'Partners',
    components: {
        Img,
    },
    props: {
        title: {
            type: String,
        },
        partners: {
            type: Array,
        },
    },
};
</script>

<style lang="scss" scoped>

    .c-partners {
    }

    .c-partners__list {
        @include reset-list;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-wrap: wrap;
        margin: -1em;

        @screen lg {
            justify-content: space-between;
        }
    }

    .c-partners__item {
        display: inline-block;
        width: 100%;
        max-width: 12em;
        margin: 1em;
    }

    .c-partners__link {
        display: block;

        img {
            @include img;
        }
    }

</style>
